var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { useMutation } from "react-query";
import { SearchTrackCatalogForm, useSearchCatalogForm, } from "./search-catalog-form";
import { SearchCatalogResult, } from "./search-catalog-result";
import { getPlaylistDetail } from "frontend/src/api/playlists";
import { PlaylistByTitleAutocomplete } from "frontend/src/pages/routes/admin/playlists/index/ui/playlist-autocomplete";
var AddPlaylistTracks = function (_a) {
    var currentPlaylistId = _a.currentPlaylistId, onTracksAdd = _a.onTracksAdd;
    var _b = React.useState(null), playlist = _b[0], setPlaylist = _b[1];
    var addPlaylist = useMutation(function (id) { return getPlaylistDetail(id); }, {
        onSuccess: function (playlistDetail) {
            onTracksAdd === null || onTracksAdd === void 0 ? void 0 : onTracksAdd(playlistDetail.tracks);
        },
    });
    var isCurrentPlaylist = (playlist === null || playlist === void 0 ? void 0 : playlist.id) === currentPlaylistId;
    return (React.createElement(Box, { component: Paper, p: 2, mt: 1 },
        React.createElement(Typography, { variant: "subtitle1" }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0440\u0435\u043A\u0438 \u0438\u0437 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u0430"),
        React.createElement(Box, { mt: 1, display: "flex", alignItems: "flex-end" },
            React.createElement(Box, { flexGrow: 1, mr: 2 },
                React.createElement(PlaylistByTitleAutocomplete, { label: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442", onChange: setPlaylist })),
            React.createElement(Button, { color: "primary", variant: "outlined", disabled: !playlist || isCurrentPlaylist || addPlaylist.isLoading, onClick: function () { return playlist && addPlaylist.mutate(playlist.id); } }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0440\u0435\u043A\u0438")),
        isCurrentPlaylist && (React.createElement(Box, { mt: 1 },
            React.createElement(Typography, { color: "error", variant: "body2" }, "\u041D\u0435\u043B\u044C\u0437\u044F \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442 \u0432 \u0441\u0430\u043C\u043E\u0433\u043E \u0441\u0435\u0431\u044F.")))));
};
export var SearchCatalog = React.memo(function (props) {
    var _a = useSearchCatalogForm(), term = _a.term, genres = _a.genres, onSubmit = _a.onSubmit, params = _a.params;
    var _b = props.showPlaylistImport, showPlaylistImport = _b === void 0 ? true : _b, _c = props.showAdminColumns, showAdminColumns = _c === void 0 ? true : _c, _d = props.showIsrcToggle, showIsrcToggle = _d === void 0 ? true : _d;
    return (React.createElement(Box, null,
        React.createElement(SearchTrackCatalogForm, { term: term, genres: genres, onSubmit: onSubmit }),
        showPlaylistImport && (React.createElement(AddPlaylistTracks, { currentPlaylistId: props.currentPlaylistId, onTracksAdd: props.onTracksAdd })),
        React.createElement(Box, { mt: 1 },
            React.createElement(SearchCatalogResult, __assign({ params: params, showAdminColumns: showAdminColumns, showIsrcToggle: showIsrcToggle }, props)))));
});
